import { InvoiceStatuses } from '@insurance/types'
import { Tag, TagProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  status?: InvoiceStatuses
}

const statusColors: Record<InvoiceStatuses, TagProps['color']> = {
  [InvoiceStatuses.IN_PROGRESS]: 'yellow',
  [InvoiceStatuses.ERROR]: 'volcano',
  [InvoiceStatuses.CANCELED]: 'error',
  [InvoiceStatuses.PAID]: 'green',
  [InvoiceStatuses.READY]: 'green-inverse',
  [InvoiceStatuses.REFUNDED]: 'blue',
  [InvoiceStatuses.PENDING_SETTLEMENT]: 'gold',
  [InvoiceStatuses.PENDING]: 'magenta',
  [InvoiceStatuses.OVERDUE]: 'red-inverse',
  [InvoiceStatuses.SCHEDULED]: 'yellow-inverse'
}

export const InvoiceStatusTag = ({ status }: Props) => {
  const { t } = useTranslation()

  if (!status) return null

  return <Tag color={statusColors[status]}>{t(status)}</Tag>
}
